"use strict";
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });
//==============================================================
// START Enums and Input Objects
//==============================================================
var BookImageStyle;
(function (BookImageStyle) {
    BookImageStyle["ORIGINAL"] = "ORIGINAL";
    BookImageStyle["PRODUCT"] = "PRODUCT";
    BookImageStyle["THUMB"] = "THUMB";
})(BookImageStyle = exports.BookImageStyle || (exports.BookImageStyle = {}));
var MediaImageType;
(function (MediaImageType) {
    MediaImageType["MEDIA_IMAGE_TYPE_UNKNOWN"] = "MEDIA_IMAGE_TYPE_UNKNOWN";
    MediaImageType["UNRECOGNIZED"] = "UNRECOGNIZED";
    MediaImageType["dataVis"] = "dataVis";
    MediaImageType["map"] = "map";
    MediaImageType["normal"] = "normal";
})(MediaImageType = exports.MediaImageType || (exports.MediaImageType = {}));
var MediaLinkType;
(function (MediaLinkType) {
    MediaLinkType["UNRECOGNIZED"] = "UNRECOGNIZED";
    MediaLinkType["external"] = "external";
    MediaLinkType["none"] = "none";
    MediaLinkType["page"] = "page";
    MediaLinkType["term"] = "term";
})(MediaLinkType = exports.MediaLinkType || (exports.MediaLinkType = {}));
var MediaType;
(function (MediaType) {
    MediaType["MEDIA_TYPE_UNKNOWN"] = "MEDIA_TYPE_UNKNOWN";
    MediaType["UNRECOGNIZED"] = "UNRECOGNIZED";
    MediaType["audio"] = "audio";
    MediaType["image"] = "image";
    MediaType["video"] = "video";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
var ResourceImageStyle;
(function (ResourceImageStyle) {
    ResourceImageStyle["ORIGINAL"] = "ORIGINAL";
    ResourceImageStyle["SMALL"] = "SMALL";
    ResourceImageStyle["THUMBNAIL"] = "THUMBNAIL";
    ResourceImageStyle["XLARGE"] = "XLARGE";
})(ResourceImageStyle = exports.ResourceImageStyle || (exports.ResourceImageStyle = {}));
var TocNodeType;
(function (TocNodeType) {
    TocNodeType["Chapter"] = "Chapter";
    TocNodeType["Page"] = "Page";
    TocNodeType["Project"] = "Project";
    TocNodeType["Section"] = "Section";
    TocNodeType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TocNodeType = exports.TocNodeType || (exports.TocNodeType = {}));
var UserType;
(function (UserType) {
    UserType["UNRECOGNIZED"] = "UNRECOGNIZED";
    UserType["instructor"] = "instructor";
    UserType["reviewer"] = "reviewer";
    UserType["student"] = "student";
    UserType["unknown"] = "unknown";
})(UserType = exports.UserType || (exports.UserType = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================
